<template>
  <div class="bindPage">
    <div class="layout">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @confirmFn="getListFn"
        @searchFn="getListFn"
        @delFn="delFn"
        @editScopeFn="editScopeFn"
        @useAgainFn="useAgainFn"
      />
      <div class="componentPage">
        <stopTable
          v-bind="$attrs"
          :loading="loading"
          :shiquArray="shiquArray"
          :tableData="tableData"
          @choozeTable="choozeTable"
          @detailFn="detailFn"
          @editScopeRowFn="editScopeRowFn"
          @useAgainRowFn="useAgainRowFn"
          @delRowFn="delRowFn"
        />
        <Pagination
          class="pagination"
          :total="total"
          :page.sync="SearchForm.iDisplayStart"
          :limit.sync="SearchForm.iDisplayLength"
          @pagination="getListFn"
        ></Pagination>
      </div>
    </div>
    <!-- 上报规则 -->
    <ruleDialog
      :isShow.sync="isShow"
      ref="rule"
      :choozeTableData="choozeTableData"
    />
    <!-- 网络参数 -->
    <netDialog
      :isShowNet.sync="isShowNet"
      ref="net"
      :choozeTableData="choozeTableData"
    />
    <!-- 配置 -->
    <configDialog
      :isShowConfig.sync="isShowConfig"
      :rowData="rowData"
      :title="title"
      ref="config"
      v-bind="$attrs"
      v-if="isShowConfig"
    />
    <!-- 详情 -->
    <detailDialog :isDetailShow.sync="isDetailShow" v-bind="$attrs" />
    <!-- 修改范围 -->
    <EditScope
      :isShowEditShow.sync="isShowEditShow"
      :scopeArray="scopeArray"
      ref="scopedId"
    />
  </div>
</template>

<script>
import formMixin from '@/utils/formMixins.js'
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import qs from 'qs'

import stopTable from './stopTable.vue'
import ruleDialog from '../components/ruleDialog.vue'
import netDialog from '../components/netDialog.vue'
import configDialog from '../components/ConfigDialog.vue'
import detailDialog from '@/components/dialog/displayDetail/displayDetailDialog.vue'
import EditScope from '../components/EditScope.vue'

import {
  contentList,
  displayDel,
  displayEdit,
  displayList
} from '@/api/modules/display.js'
import { shareScope } from '@/api/modules/public.js'
import { getPermission } from '@/utils/permission'
import { deviceListCarrierPreHandle } from '@/pages/equipment/common/preHandle'

export default {
  mixins: [formMixin, getAllTreePath],
  components: {
    stopTable,
    ruleDialog,
    netDialog,
    configDialog,
    detailDialog,
    EditScope
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newval) {
        this.formContent[1].selectParam = newval
      },
      immediate: true
    }
  },
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'device.display_name',
          type: 'input',
          paramsName: 'name',
          isChooze: true
        },
        {
          id: 6,
          text: 'device.display_type',
          type: 'select',
          paramsName: 'type',
          isChooze: false,
          selectParam: []
        },
        {
          id: 3,
          text: 'public.carrier',
          type: 'input',
          paramsName: 'carrierName',
          isChooze: false
        }
      ],
      SearchForm: {
        name: null,
        carrierName: null,
        scopeName:
          this.$store.state.SchemaTree[0].sceneCode === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        type: ''
      },
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.tbopt_delete',
          method: 'delFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.reuse',
          method: 'useAgainFn'
        }
      ],
      shiquArray: [],
      isShow: false,
      choozeTableData: [],
      // 网络参数
      isShowNet: false,
      // 配置
      isShowConfig: false,
      title: '',
      rowData: {},
      // 详情
      isDetailShow: false,
      detailObj: {},
      // 修改范围
      isShowEditShow: false,
      scopeArray: [],
      deviceType: {},
      detailNetObj: {},
      deviceProperty: {}
    }
  },
  created () {
    this.contentListFn()
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (getPermission() === 'noSysNoAdmin') {
      this.optareBtn.pop()
    }
    if (
      getPermission() === 'isSysAdmin' ||
      getPermission() === 'isSysNoAdmin'
    ) {
      this.optareBtn.push({
        id: 3,
        icon: '',
        vHas: ['incubatorAddCarrier'],
        text: 'device.modify_customer',
        method: 'editScopeFn'
      })
    }
  },
  methods: {
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    /** 时区 */
    contentListFn () {
      if (this.shiquArray.length > 0) return
      contentList({
        code: 'ADMIN_CONFIG_LABEL_NOTICE_ZONE',
        type: 0
      }).then(({ result }) => {
        this.shiquArray = result
      })
    },
    /** 分页 */
    getListFn () {
      this.loading = true
      displayList(this.SearchForm, 'stop')
        .then(({ result, pageInfo }) => {
          this.tableData = result.map(item => {
            // item.carrierNameArray = item.carrierName ? item.carrierName.split(',') : []
            // item.sceneNameArray = item.sceneName ? item.sceneName.split(',') : []
            item.carrierList = deviceListCarrierPreHandle(item)
            return item
          })
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetFn () {
      this.SearchForm = {
        name: null,
        carrierName: null,
        type: '',
        scopeName:
          this.$store.state.SchemaTree[0].sceneCode === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      bus.$emit('initTree')
      this.treePathObj =
        this.$store.state.SchemaTree[0].scene_code === 'all_node'
          ? null
          : this.$store.state.SchemaTree[0].label
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 详情 */
    detailFn (row) {
      this.isDetailShow = true
      bus.$emit('displayParam', row.id, row.name, row.scopeName)
    },
    /** 重新使用 */
    useAgainRowFn (row) {
      const query = qs.stringify({
        ids: row.id,
        status: 0
      })
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          displayEdit(query, 'use').then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 获取范围 */
    getSence () {
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    /** 多条修改范围 */
    editScopeFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const flag = this.distinguishTypeFn('scene_id')
      if (!flag) {
        return this.$message.error(
          $t('integration.the_selected_display_screen_is_not_the_same_customer')
        )
      }
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId =
          this.choozeTableData[0].sceneId + ''
        this.$refs.scopedId.dioForm.ids = this.choozeTableData
          .map(item => item.id)
          .join(',')
      })
    },
    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true

      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam[str] !== item[str]) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },
    /** 单条修改范围 */
    editScopeRowFn (row) {
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId = row.sceneId + ''
        this.$refs.scopedId.dioForm.ids = row.id
      })
    },
    /** 重新使用 */
    useAgainFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const idList = this.choozeTableData.map(item => item.id)
      const query = qs.stringify({
        ids: idList.join(','),
        status: 0
      })
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          displayEdit(query, 'use').then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 多条删除 */
    delFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const idList = this.choozeTableData.map(item => item.id)
          const query = {
            ids: idList.join(','),
            edited: 1
          }

          displayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条删除 */
    delRowFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = {
            ids: row.id,
            edited: 1
          }

          displayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
  width: 100%;
  height: 100%;
  padding-right: 15px;
  box-sizing: border-box;

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
